export type Theme = 'auto' | 'light' | 'dark';

const STORAGE_KEY = 'b4b-theme';

export function applyTheme(theme: Theme): void {
  localStorage.setItem(STORAGE_KEY, theme);
  const dark =
    theme === 'dark' ||
    (theme === 'auto' && window.matchMedia('(prefers-color-scheme: dark)').matches);
  document.documentElement.classList.toggle('dark', dark);
}

export function getStoredTheme(): Theme {
  const value = localStorage.getItem(STORAGE_KEY);
  return value === 'light' || value === 'dark' ? value : 'auto';
}

export function watchSystemTheme(): void {
  window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', () => {
    applyTheme(getStoredTheme());
  });
}
